const CONTENT_PROPS = ['linkedin_url', 'email', 'user_id', 'description'];

export function speakerHasContent(speaker) {
    for (let prop of CONTENT_PROPS) {
        if (speaker[prop]) {
            return true;
        }
    }
    return false;
}
